<template>
  <div class="page-content-wrapper">
    <div class="content">
      <div class="container-fluid container-fixed-lg">
        <div class="row p-3">
          <div class="col-lg-12">
            <h2 class="text-dag">{{ $t('menu_tips') }}</h2>
          </div>
        </div>
        <div class="row p-3">
          <div class="col-lg-3 m-b-10"
               v-for="tip in getTips">
            <div class="card no-border widget-loader-circle no-padding rounded h-100">
              <router-link class="card-link-24"
                           :to="{ name: 'tipspage', params: { tip_id: tip.Id} }">
                <div class="card-header"
                     :class="getShiftClass.box[0]">
                </div>
                <div class="card-body text-center p-t-20 p-b-30">
                  <div class="card-icon">
                    <img v-if="tip.Image"
                         :src="require(`@/assets/img/Food icons/${tip.Image}`)"
                         width="100">
                  </div>
                  <div class="card-link card-link-24"
                       :class="getShiftClass.td[0]">
                    {{ tip.Title }}
                  </div>
                </div>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { mapActions } from 'vuex'

  export default {
    computed: {
      ...mapGetters([
        'getShiftClass',
        'getTips',
      ]),
    },
    methods: {
      ...mapActions([
        'loadTips',
      ]),
    },
    created() {
      this.loadTips()
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/info/Tips.vue